import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Aisha Agarwal </span>
            from <span className="purple"> Moradabad, India.</span>
            
           
            
           
          </p>
         
          <p style={{ color: "rgb(155 126 172)" }}>
            "Life is 10 % of what happens to it and 90% of how we react to it"{" "}
          </p>
          <footer className="blockquote-footer">Aisha</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
